import { Component, OnInit , ElementRef, ViewChild } from '@angular/core';
// import { TranslateService } from '@ngx-translate/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {  AuthService } from '../../../services/auth.service'
import { DomSanitizer, Title } from '@angular/platform-browser';
import { UntypedFormControl, FormGroupDirective, NgForm, Validators, UntypedFormGroup, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DatePipe } from '@angular/common';
import * as $ from 'jquery';
import { Router, ActivatedRoute} from "@angular/router";
import { useractivationService } from '../../../../admin/services/useractivation.service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: [ './login.component.css','./../../home/home.component.css'],
  animations: [
    trigger('ShowHide', [
      state('spinning', style({ opacity:1 })),
      state('stopped', style({ opacity: 0, display:'none' })),
      transition('spinning => stopped', [ animate('300ms') ]),
      transition('stopped => spinning', [ animate('300ms') ]),

    ]),
  ]
})
export class LoginComponent implements OnInit {

  ShowLoginPage:boolean=true
  ShowForogtPass:boolean=false
  ShowCreateAccount:boolean=false

  BannerURL:any;
  loginForm: UntypedFormGroup;
  OTPForm : UntypedFormGroup;
  today:any='';

  
  submitted = false;
  loaderspinning = false;
  invalidCred = false;
  LockedCred = false;
  ActiveCred = false;
  
  profileLockCount:number = 0;
  LoginObject:any={};
  ShowOtpForm : boolean = false;
  ShowOtpValidationMsg : boolean = false;

  constructor(
    // private translate: TranslateService,
    private authServObj: AuthService,
    private sanitizer: DomSanitizer,
    private datePipe:DatePipe,
    private activatedRoute : ActivatedRoute,
    private useractivationServ : useractivationService
  ) {
    localStorage.setItem("lang",'en')
    // translate.setDefaultLang(localStorage.getItem('lang'));
   }

  ngOnInit(): void {

    this.activatedRoute.paramMap.subscribe(params => {
      if(params.get('pagetype') == "webregistration"){
        this.ShowForogtPass=false;
        this.ShowLoginPage=false
        this.ShowCreateAccount=true;
        this.RegClassAdd()
      }
    })

    this.authServObj.GetBannerDetail({PAGENAME:'HOME'}).subscribe(BannerDetailRes => {
      try{
        if(BannerDetailRes.success == true){
          if(BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "MP4" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "MOV"){
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<video id="fst-video" loop autoplay muted style="width:100%;height:100%;"><source src='+BannerDetailRes.data[0].URL+' type="video/mp4"></video>') ;
          }else if(BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "PNG" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "JPG" || BannerDetailRes.data[0].URL_TYPE.toUpperCase() == "JPEG" ){
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src='+BannerDetailRes.data[0].URL+'>') ;
          }else{
            this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
          }
        }else{
          this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
        }
      }catch(err){
        this.BannerURL =  this.sanitizer.bypassSecurityTrustHtml('<img style="object-fit:cover;width:auto;max-width:100%;padding: 0;" src="https://pcknstg.blob.core.windows.net/hdfile/webimg/login_event.png"/>') ;
        console.log("err",err)
      }
    })

    this.today =this.datePipe.transform( new Date(),'yyyy-MM-dd  h:mm:ss a');

    this.loginForm = new UntypedFormGroup({
      'username': new UntypedFormControl('', [Validators.required]),
      'password': new UntypedFormControl('', [Validators.required]),
      'todayDate':new UntypedFormControl(this.today, []),
    });

    this.OTPForm = new UntypedFormGroup({
      OTP: new UntypedFormControl("", [Validators.required]),
    });

  }

  get username() { return this.loginForm.get('username'); }
  get password() { return this.loginForm.get('password'); }
  get todayDate() { return this.loginForm.get('todayDate'); }
  get OTP() { return this.OTPForm.get('OTP'); }

  

  onLoginFormSubmit() {
    this.submitted = true;
    this.loaderspinning = true;

    if(this.loginForm.valid){
      this.authServObj.loginService(this.loginForm.value.username.trim(),this.loginForm.value.password,this.loginForm.value.todayDate).subscribe(apiResp => {

        if(apiResp){

          if(apiResp.message == "Your account is Locked"){
            this.invalidCred = false;
            this.loaderspinning = false;
            this.LockedCred = true;
            this.ActiveCred = false;
            return;
          }

          if(apiResp.message == "Your account is not active"){
            this.invalidCred = false;
            this.loaderspinning = false;
            this.LockedCred = false;
            this.ActiveCred = true;
            return;
          }
          // if(apiResp.token){
          //   if((apiResp.Cat).toUpperCase() == 'S' && ((apiResp.UserId).toUpperCase() == 'ADMIN' || (apiResp.UserId).toUpperCase() == 'APSAVALIYA')){
          //     this.LoginObject = apiResp;
          //     this.ShowOtpForm = true;
          //     this.loaderspinning = false;

          //     this.invalidCred = false;
          //     this.loaderspinning = false;
          //     this.LockedCred = false;
          //     this.ActiveCred = false;
          //     return;
          //   }
          //   localStorage.setItem('access_token', apiResp.token);
          // }

          localStorage.setItem("LastLogin", apiResp.LastLogin);

          $('body').removeClass('modal-open');
          $('.modal-backdrop').remove();

          if(apiResp.Cat =="U"){
            window.location.href = window.location.origin+'/userpanel';

          }else if(apiResp.Cat =="S"){
            window.location.href = window.location.origin+'/adminpanel';
          }else if(apiResp.Cat =="K"){
            window.location.href = window.location.origin+'/adminpanel';
          }else if(apiResp.Cat =="B"){
            window.location.href = window.location.origin+'/userpanel';
          }else if(apiResp.Cat =="E"){
            window.location.href = window.location.origin+'/adminpanel';
          }else{
            if((this.loginForm.value.username.trim()).toUpperCase() == "ADMIN"){
              this.profileLockCount += 1;
              if(this.profileLockCount == 5){
                this.useractivationServ.toggleLockedV2({}).subscribe((Res)=> {});
              }
            }
            this.loaderspinning = false;
            this.invalidCred = true;
            this.LockedCred = false;
          }
        }else{
          this.loaderspinning = false;
          this.invalidCred = true;
          this.LockedCred = false;
        }
      });
    }else{
      this.loaderspinning = false;
    }
  }

  RegClassAdd(){
    $('.md_log').addClass('reg_active');
  }

  onLoginFormSubmitWithOTP(){
    if(this.OTPForm.value.OTP == "" || this.OTPForm.value.OTP == null){
      this.ShowOtpValidationMsg = true;
      return;
    }

    this.loaderspinning = true
    this.authServObj.GetOTPWeb({"EMAILID":this.LoginObject.EMailId}).subscribe((ORes)=>{
      this.loaderspinning = false
      try {
        if(ORes.success == true){
          if(ORes.data == ""){
            Swal.fire({
              icon: 'error',
              title: 'OTP not found. Please Contact system administrator.',
              showConfirmButton: true,
              timer: 2500
            })
            return
          }else{
            const decrypt = (salt, encoded) => {
              const textToChars = (text) => text.split("").map((c) => c.charCodeAt(0));
              const applySaltToChar = (code) => textToChars(salt).reduce((a, b) => a ^ b, code);
              return encoded
                .match(/.{1,2}/g)
                .map((hex) => parseInt(hex, 16))
                .map(applySaltToChar)
                .map((charCode) => String.fromCharCode(charCode))
                .join("");
            };

            const decrypted_string = decrypt("N@r0l@Gem$CRM", ORes.data);

            if(decrypted_string == this.OTPForm.value.OTP){
              localStorage.setItem('access_token', this.LoginObject.token);
              
              localStorage.setItem("LastLogin", this.LoginObject.LastLogin);

              $('body').removeClass('modal-open');
              $('.modal-backdrop').remove();


              if(this.LoginObject.Cat =="U"){
                window.location.href = window.location.origin+'/userpanel';
    
              }else if(this.LoginObject.Cat =="S"){
                window.location.href = window.location.origin+'/adminpanel';
              }else if(this.LoginObject.Cat =="K"){
                window.location.href = window.location.origin+'/adminpanel';
              }else if(this.LoginObject.Cat =="B"){
                window.location.href = window.location.origin+'/userpanel';
              }else if(this.LoginObject.Cat =="E"){
                window.location.href = window.location.origin+'/adminpanel';
              }

            }else{
              Swal.fire({
                icon: 'error',
                title: 'OTP is not match.',
                showConfirmButton: true,
                timer: 2500
              })
            }
          }

        }else{
          Swal.fire({
            icon: 'error',
            title: 'Something went wrong. Please Contact system administrator.',
            showConfirmButton: true,
            timer: 2500
          })
        }
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: error,
          showConfirmButton: true,
          timer: 2500
        })
      }
    })
  }
}
